<template>
    <div id="nissan-quiz-getready-ipad" class="nissan-quiz-screen">

      <div class="getReadyGame">GAME</div>
      <div class="getReadyOn">ON!</div>
      <div v-if="this.config.tierType !== 'TIER3'">
        <div class="getReadyH1">Get Ready for<br>your first question</div>
        <div class="getReadyH2" v-if="this.config.tierType === 'TIER1' || this.config.tierType === 'TIER2'">
          Answer all 10 multiple choice<br>
          questions correctly to win.<br>
          Do it in the fastest time,<br>
          and you could win big!
        </div>
        <div class="getReadyH2" v-if="this.config.tierType === 'TSF' || this.config.tierType === 'CORP'">
          Answer all questions<br>
          correctly to win.<br>
          Do it in the fastest time,<br>
          and you could win big!
        </div>
      </div>
      <div v-else>
        <div class="getReadyH1">Hit PLAY to begin</div>
        <div
          @click="readyToPlay"
          id="ReadyToPlayNextButton"
          class="nissan-quiz-nextbutton"
        >
          <span>PLAY</span>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GameOn',
  data() {
    return {
      isPlaying: false,
    };
  },
  computed: {
    ...mapGetters([
      'config',
    ]),
  },
  methods: {
    readyToPlay() {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.$root.$emit('requestNextQuestion');

        this.$keen.recordEvent('tier3Start', {
          numberofplayer: 1,
          eventName: this.$store.state.eventId,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';

#nissan-quiz-getready-ipad {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;

}
.getReadyGame {
  font-size: 60px;
  text-align:center;
  width: 100%;
  margin-top: 100px;
  font-family: 'Nissan-Brand-Bold';
}

.getReadyOn {
  text-align:center;
  width: 100%;
  font-size: 100px;
  font-family: 'Nissan-Brand-Bold';
}

.getReadyH1{
  margin-top: 20px;
  text-align:center;
  width: 100%;
  font-size: 25px;
  font-family: 'Nissan-Brand-Light';
}

.getReadyH2{
  margin-top: 10px;
  text-align:center;
  width: 100%;
  font-size: 20px;
  font-family: 'Nissan-Brand-Light';
}

@media only screen and (max-width: 320px) {
  .getReadyGame {
    margin-top: 50px;
  }
}
</style>
